import {
  START_SESSION_POLLING,
  STOP_SESSION_POLLING
} from '../store/action-types';

/**
 * Starts the session polling.
 * @return {*} start session polling action.
 */
export function startSessionPolling() {
  return {
    type: START_SESSION_POLLING
  };
}

/**
 * Stops the session polling.
 * @return {*} stop session polling action.
 */
export function stopSessionPolling() {
  return {
    type: STOP_SESSION_POLLING
  };
}
